import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosInstance } from "../../Component/utils/axiosInstance";
import toast from "react-hot-toast";

const ForgetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Extract the 'token' parameter

  const navigate = useNavigate();

  const validationSchema = Yup.object({
    password: Yup.string().required("Password is required"),
    confirmpassword: Yup.string().required("Confirm Password is required"),
  });
  const initialValues = {
    password: "",
    confirmpassword: "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData();

      formData.append("token", token);
      formData.append("password", values?.password);
      formData.append("confirm_password", values?.confirmpassword);

      const response = await axiosInstance.post(
        "user/reset/password",
        formData
      );
      if (response.data.status === true) {
        toast.success(response.data.message || "Please Check Your Email..!");
        navigate("/signin");
      }
    } catch (error) {
      const { message } = error?.response?.data;
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container" style={{ height: "100vh" }}>
      <div className="row align-items-center h-100">
        <div className="col-lg-5 col-md-6">
          <img
            src="/images/loginImg.png"
            className="img-fluid d-block my-auto"
            alt="Login Illustration"
          />
        </div>
        <div className="col-lg-6 col-md-6 ms-auto">
          <img
            src="/images/registerLogo.png"
            className="w-25 d-block mx-auto pb-4"
            alt="Register Logo"
          />
          <h1 className="fw-bolder text-black fs-2 py-2">Forget Password</h1>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <label className="fw-bolder text-secondary fs-6 pt-1">
                  Enter Password
                </label>
                <Field
                  type="password"
                  name="password"
                  className="form-control border-2 border-secondary py-2 fw-semibold"
                  placeholder="Password"
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-danger"
                />

                <label className="fw-bolder text-secondary fs-6 pt-3">
                  Confirm Password
                </label>
                <Field
                  type="password"
                  name="confirmpassword"
                  className="form-control border-2 border-secondary py-2 fw-semibold"
                  placeholder="Confirm Password"
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-danger"
                />

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-danger w-100 fw-bold py-2 fs-6 mt-3"
                  style={{ background: "#CD2128", border: "none" }}
                >
                  {isSubmitting ? "Signing In..." : "Sign In"}
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
